/**  Класс для сообщения из чата */
export class Region {
  /** Можно ли выбирать */
  public Name: string = '';


  /**
   * Конструктор с загрузкой данных из ответа сервера.
   * @param src данные с сервера
   */
  constructor(src: any) {
    if (src) {
      this.Name = src ?? '';
    }
  }
}
